import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef, MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import * as _ from "lodash";
import * as moment from "moment";
import { Subscription } from "rxjs/Subscription";
import { environment } from "../../../../../environments/environment";
import { fuseAnimations } from "../../../../core/animations";
import { FuseConfirmDialogComponent } from "../../../../core/components/confirm-dialog/confirm-dialog.component";
import { WindowRef } from "../../../../core/components/window/window.service";
import {
    OrderItemResult,
    OrderResult,
} from "../../../../core/services/orders/order.models";
import {
    DIRECTION,
    ORDER_STATUS,
} from "../../../../core/services/orders/orders.constant";
import { Transaction } from "../../../../core/services/transactions/transactions.model";
import { PRODUCT_TYPE } from "../booking/booking.constants";
import { Product } from "../product/product.model";
import { DashboardOrderService } from "./order.service";
import { TicketAddFormDialogComponent } from "./ticket-add-form/ticket-add-form.component";
import { TransacFormDialogComponent } from "./transac-form/transac-form.component";

@Component({
    selector: "fuse-order",
    templateUrl: "./order.component.html",
    styleUrls: ["./order.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class OrderComponent implements OnInit, OnDestroy {
    orderForm: FormGroup;
    order: OrderResult;
    onOrderChanged: Subscription;

    transactions: Transaction[];
    onTransactionChanged: Subscription;

    dueAmount: number;
    onDueAmountChanged: Subscription;

    statusForm: FormGroup;
    // orderStatuses = [];
    dialogRef: any;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    nativeWindow: any;

    constructor(
        readonly orderService: DashboardOrderService,
        private formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        private router: Router,
        private readonly winRef: WindowRef
    ) {
        this.nativeWindow = winRef.getNativeWindow();
    }

    ngOnInit() {
        // Subscribe to update order on changes
        this.onOrderChanged = this.orderService.onOrderChanged.subscribe(
            (order: OrderResult) => {
                this.order = order;
            }
        );

        this.onTransactionChanged =
            this.orderService.onTransactionChanged.subscribe(
                (transactions: Transaction[]) => {
                    this.transactions = transactions;
                }
            );

        this.onDueAmountChanged =
            this.orderService.onDueAmountChanged.subscribe((amount: number) => {
                this.dueAmount = amount;
                if (localStorage.getItem("booked") === "1") {
                    this.addTransac();
                }
            });

        this.orderForm = this.formBuilder.group({
            // comment: [null, Validators.required],
        });
    }

    showInvoice(id) {
        this.router.navigate(["/invoice", id]);
    }

    openCalendar() {
        const url =
            environment.apiUrl + "/orders/" + this.order._id + "/calendar.ics";
        const newWindow = this.nativeWindow.open(url);
    }

    updateStatus() {
        this.orderService
            .setStatus(this.statusForm.get("newStatus").value)
            .then(() => {
                this.snackBar.open(
                    `Le statut de la commande a bien été mis à jour.`,
                    "OK",
                    {
                        verticalPosition: "top",
                        duration: 3000,
                    }
                );
            })
            .catch((e) => {
                this.snackBar.open("Une erreur est survenue !", "OK", {
                    verticalPosition: "bottom",
                    duration: 2000,
                });
            });
    }

    addTransac() {
        // const due = this.order.status === P
        this.dialogRef = this.dialog.open(TransacFormDialogComponent, {
            panelClass: "transac-form-dialog",
            data: {
                action: "new",
                dueAmount: this.dueAmount,
            },
        });
        this.dialogRef.afterClosed().subscribe((response: FormGroup) => {
            if (!response) {
                localStorage.removeItem("booked");
                return;
            }
            const newTransac = response.getRawValue();
            this.orderService
                .addTransac(newTransac)
                .then(() => {
                    if (localStorage.getItem("booked") === "1") {
                        if (newTransac.vads_amount === this.dueAmount) {
                            const url =
                                location.protocol +
                                "//" +
                                location.host +
                                "/invoice/" +
                                this.order._id;
                            const newWindow = this.nativeWindow.open(url);
                        }
                        localStorage.removeItem("booked");
                    }
                })
                .catch((e) => {
                    this.snackBar.open("Une erreur est survenue !", "OK", {
                        verticalPosition: "bottom",
                        duration: 2000,
                    });
                });
        });
    }

    /**
     * Delete
     */
    deleteOrder(id: string, status: string) {
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        this.confirmDialogRef.componentInstance.confirmMessage = `Veuillez confirmer l'annulation de le réservation réf.${id}`;

        this.confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                const cancelstatus =
                    status ===
                    (ORDER_STATUS.PREORDER_RESERVED ||
                        ORDER_STATUS.PREORDER_CONFIRMED ||
                        ORDER_STATUS.PREORDER_AWAITING_PAYMENT)
                        ? ORDER_STATUS.PREORDER_CANCELED
                        : ORDER_STATUS.CANCELED;
                this.orderService
                    .setStatus(cancelstatus)
                    .then(() => {
                        this.snackBar.open(`Commande ${id} annulée.`, "OK", {
                            verticalPosition: "top",
                            duration: 3000,
                        });
                    })
                    .catch((e) => {
                        this.snackBar.open(
                            `Annulation impossible, une erreur est survenue.`,
                            "OK",
                            {
                                verticalPosition: "top",
                                duration: 3000,
                            }
                        );
                    });
            }
            this.confirmDialogRef = null;
        });
    }

    refundOrder(id) {
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        this.confirmDialogRef.componentInstance.confirmMessage = `Veuillez confirmer le remboursement de la commande réf. ${id}`;

        this.confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.orderService
                    .refund()
                    .then(() => {
                        this.snackBar.open(
                            `Commande ${id} remboursée avec succès.`,
                            "OK",
                            {
                                verticalPosition: "top",
                                duration: 7000,
                            }
                        );
                    })
                    .catch((e) => {
                        this.snackBar.open(
                            `Remboursement impossible, une erreur est survenue.`,
                            "OK",
                            {
                                verticalPosition: "top",
                                duration: 9000,
                            }
                        );
                    });
            }
            this.confirmDialogRef = null;
        });
    }

    resendEmail() {
        this.orderService.resendEmail(this.order._id).subscribe((result) => {
            this.snackBar.open(`Email envoyé avec succès.`, "OK", {
                verticalPosition: "top",
                duration: 7000,
            });
        });
    }

    sendPaymentLink() {
        this.orderService
            .sendPaymentLink(this.order._id)
            .subscribe((result) => {
                this.snackBar.open(`Email envoyé avec succès.`, "OK", {
                    verticalPosition: "top",
                    duration: 7000,
                });
            });
    }

    sendPreorderPaymentReminder() {
        this.orderService
            .sendPaymentReminder(this.order._id)
            .subscribe((result) => {
                this.snackBar.open(`Email envoyé avec succès.`, "OK", {
                    verticalPosition: "top",
                    duration: 7000,
                });
            });
    }

    saveOrder() {
        try {
            this.checkOrder();
        } catch (e) {
            return;
        }
    }

    save() {
        this.orderService
            .saveOrder(this.order)
            .then(() => {
                this.snackBar.open(`Commande sauvegardée avec succès.`, "OK", {
                    verticalPosition: "top",
                    duration: 7000,
                });
                this.orderForm.markAsPristine();
            })
            .catch((e) => {
                this.snackBar.open(
                    "Une erreur est survenue lors de la sauvegarde, veuillez vérifier la disponibilité des produits !",
                    "OK",
                    {
                        verticalPosition: "bottom",
                        duration: 8000,
                    }
                );
            });
    }

    setComment(event: any) {
        // console.log(event.target.value);
        this.orderForm.markAsDirty();
    }

    confirmPreOrder() {
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        // this.confirmDialogRef.componentInstance.confirmTitle = "Confirmation de votre réservation";
        this.confirmDialogRef.componentInstance.confirmMessage = `Souhaitez-vous confirmer / signer cette réservation et la basculer en attente de règlement ?`;

        this.confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.orderService
                    .setStatus(ORDER_STATUS.PREORDER_AWAITING_PAYMENT)
                    .then(() => {
                        this.snackBar.open(
                            `Réservation confirmée avec succès`,
                            "OK",
                            {
                                verticalPosition: "top",
                                duration: 7000,
                            }
                        ) /*.afterDismissed().subscribe(
                        () => {
                            this.router.navigate(['/dashboard/bc']);
                        }
                    )*/;
                    })
                    .catch((e) => {
                        this.snackBar.open(
                            `Confirmation impossible, une erreur est survenue.`,
                            "OK",
                            {
                                verticalPosition: "top",
                                duration: 9000,
                            }
                        );
                    });
            }
            this.confirmDialogRef = null;
        });
    }

    deleteOrderItem(id: string) {
        console.log(`item ${id} deleted`);
        const index = this.order.items.findIndex((t) => t._id === id);
        this.order.items.splice(index, 1);
        this.orderForm.markAsDirty();
    }

    changeOrderItem(event: any) {
        this.orderForm.markAsDirty();
    }

    addTicket() {
        // const order = this.order;
        this.dialogRef = this.dialog.open(TicketAddFormDialogComponent, {
            panelClass: "ticket-form-add-dialog",
            data: {
                type: this.order.type,
                product: this.order.items[0].product,
                category: this.order.category,
                date: this.order.items[0].date,
            },
        });
        this.dialogRef.afterClosed().subscribe((response: FormGroup) => {
            const newTicket = response.getRawValue();
            if (!newTicket.productId.length) {
                this.snackBar.open(
                    "Impossible de modifier une commande dont la date est dépassée",
                    "OK",
                    {
                        verticalPosition: "bottom",
                        duration: 6000,
                    }
                );
                return;
            }
            // if (
            //     this.order.type === PRODUCT_TYPE.CRUISE &&
            //     this.order.items[0].product !== newTicket.productId
            // ) {

            // }
            // console.log(newTicket);
            const item: OrderItemResult = {
                _id: null,
                ticket: null,
                title: null,
                title_en: null,
                price: null,
                quantity: 1,
                vatRate: null,
                boarded: null,
                amount: null,
                amountVAT: null,
                amountTotal: null,
                date: new Date(newTicket.bookingDate),
                product: { _id: newTicket.productId } as Product,
            };
            this.order.items.push(item);
        });
    }

    checkOrder() {
        if (this.order.type === PRODUCT_TYPE.SHUTTLE) {
            let productIds;
            if (typeof this.order.items[0].product === "string") {
                productIds = _.uniq(_.map(this.order.items, "product"));
            } else {
                productIds = _.uniq(_.map(this.order.items, "product._id"));
            }

            if (
                this.order.direction === DIRECTION.ONEWAY &&
                productIds.length !== 1
            ) {
                return this.askRoundTripDirection();
            } else if (
                this.order.direction === DIRECTION.ROUNDTRIP &&
                productIds.length !== 2
            ) {
                this.order.direction = DIRECTION.ONEWAY;
            }
        }
        this.save();
    }

    askRoundTripDirection() {
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        this.confirmDialogRef.componentInstance.confirmMessage = `Attention vous allez modifier votre trajet "aller-simple" en un trajet "aller-retour", veuillez confirmer le changement :`;

        this.confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.order.direction = DIRECTION.ROUNDTRIP;
                this.save();
            } else {
                this.snackBar.open("Sauvegarde annulée", "OK", {
                    verticalPosition: "bottom",
                    duration: 6000,
                });
                this.order.items.splice(-1);
            }
            this.confirmDialogRef = null;
        });
    }

    confirmOrder() {
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        this.confirmDialogRef.componentInstance.confirmMessage = `Souhaitez-vous confirmer l'option de réservation réf. ${this.order._id}`;

        this.confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.orderService
                    .setStatus(ORDER_STATUS.PREORDER_CONFIRMED)
                    .then(() => {
                        this.snackBar.open(
                            `Réservation ${this.order._id} confirmée avec succès.`,
                            "OK",
                            {
                                verticalPosition: "top",
                                duration: 7000,
                            }
                        );
                    })
                    .catch((e) => {
                        this.snackBar.open(
                            `Confirmation impossible, une erreur est survenue.`,
                            "OK",
                            {
                                verticalPosition: "top",
                                duration: 9000,
                            }
                        );
                    });
            }
            this.confirmDialogRef = null;
        });
    }

    isExpired() {
        const date = moment(this.order.items[0].date);
        const dateStr = date.format("YYYY-MM-DD");
        const departure = moment(
            dateStr + " " + this.order.items[0].time || "07:00"
        );
        return moment().isAfter(departure);
    }

    hasBoardedItems() {
        return this.order.items.some((item) => item.boarded > 0);
    }

    ngOnDestroy() {
        this.onOrderChanged.unsubscribe();
        this.onTransactionChanged.unsubscribe();
        this.onDueAmountChanged.unsubscribe();
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/order/order.component.ts